/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2022 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 *
 * Created by H144765 on 4/4/2022.
 */

import React from 'react'
import {withRouter} from 'react-router'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {FormattedMessage, injectIntl} from 'react-intl'
import * as FaultActions from '../FaultActions'
import * as SecurityActions from '../../security/SecurityActions'
import BreadCrumb from '../../common/Bradcrumb'
import {getBreadcrumbItemsFault, verifyAirtimeException} from "../../utils/Helpers"
import WorkflowTree from './WorkflowTree'
import {FAULT_STATES, isClosedState} from "../common/FaultsConst";
import Loader from "../../common/Loader";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";

class Dwp extends React.Component {
    constructor(props) {
        super(props)

        const {intl} = this.props

        this.state = {
            tree: null,
            loading: false,
        }

        this.workflowTree = new WorkflowTree(intl)

        this.fetchFault = this.fetchFault.bind(this)
        this.fetchDwp = this.fetchDwp.bind(this)
    }

    componentDidMount() {
        const { match: { params } } = this.props;
        this.setState({loading: true})
        Promise.all([
            this.fetchFault(params.assetId, params.faultId),
            this.fetchDwp(params.assetId, params.faultId),
        ]).then(() => {
            this.setState({loading: false})
            this.workflowTree.build(this.props.fault.dwp)
        })
    }

    fetchFault(assetId, faultId) {
        const {history} = this.props;

        return this.props.FaultActions.fetchDetails(assetId, faultId).then(() => {
            if (this.props.fault.error === null && this.props.fault.details && (this.props.fault.details.faultConditionState === FAULT_STATES.DELETED || isClosedState(this.props.fault.details.faultConditionState))) {
                history.push(`/assets/${assetId}/faults/${faultId}`)
            }
        }).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    fetchDwp(assetId, faultId) {
        return this.props.FaultActions.fetchDwp(assetId, faultId).catch(ex => {
            verifyAirtimeException(ex.errorKey, this.props.SecurityActions.signOut)
        });
    }

    render() {
        const {intl, fault} = this.props

        return(
            <React.Fragment>
                {this.renderBreadcrumb(intl, fault)}
                <h1><FormattedMessage id="dwp.title" /></h1>
                <div id="dwpContainer"></div>
                <Loader loading={this.state.loading}/>
            </React.Fragment>
        );
    }

    renderBreadcrumb(intl, fault) {
        const {security} = this.props
        if (fault && fault.details && fault.details.name) {
            return (<BreadCrumb items={getBreadcrumbItemsFault(fault.details,
                userHasActivity(security.userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? intl.formatMessage({id: "admin.tab.only.assets"}) : null,
                intl.formatMessage({id: "fault.detail.button.workplan"}),
                userHasActivity(security.userProfile, ACTIVITY_TYPES.EXTERNAL_ACTIVITY))} />)
        }
        return('');
    }

    componentWillUnmount() {
        this.workflowTree.destroy()
    }
}

const mapStateToProps = (state) => {
    return {
        fault: state.fault,
        security: state.security,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        FaultActions: bindActionCreators(FaultActions, dispatch),
        SecurityActions: bindActionCreators(SecurityActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Dwp)))